import { render, staticRenderFns } from "./deliveryHours.vue?vue&type=template&id=08d2f9aa"
import script from "./deliveryHours.vue?vue&type=script&lang=js"
export * from "./deliveryHours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08d2f9aa')) {
      api.createRecord('08d2f9aa', component.options)
    } else {
      api.reload('08d2f9aa', component.options)
    }
    module.hot.accept("./deliveryHours.vue?vue&type=template&id=08d2f9aa", function () {
      api.rerender('08d2f9aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sites/brand/overview/deliveryHours.vue"
export default component.exports